import React from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  selectIsTrackClosed,
  selectCalculatedElectricalInstallation,
  setCalculatedElectricalInstallation,
  selectAccessories,
  selectPowerSupplies,
  selectNbSegments
} from "../../../store/slices/mc12";

import t from "../../../utils/common/translation/translator";
import { genPowerGroup } from "../../../utils/Mc12/func.utils";
import MsxIcons from "../../common/Icons/MsxIcons/MsxIcons";

const AddPowerGroup = ({ disabled }) => {
  const dispatch = useDispatch();
  const calculatedElectricalInstallation = useSelector(selectCalculatedElectricalInstallation);
  const isTrackClosed = useSelector(selectIsTrackClosed);
  const accessories = useSelector(selectAccessories);
  const powerSupplies = useSelector(selectPowerSupplies);
  const nbSegments = useSelector(selectNbSegments);

  const addGroup = () => {
    const tmpCalculatedElectricalInstallation = JSON.parse(JSON.stringify(calculatedElectricalInstallation));
    const powerGroup = genPowerGroup(powerSupplies, accessories);
    powerGroup.id =
      tmpCalculatedElectricalInstallation.powerGroups[tmpCalculatedElectricalInstallation.powerGroups.length - 1].id +
      1;
    powerGroup.powerSupply.quantity = 1;
    powerGroup.connectionModule.quantity = 1;
    powerGroup.powerInterPlug.quantity = 1;
    const defaultPowerCableIndex = powerGroup.powerCables.findIndex((cable) => cable.length === 6);
    if (defaultPowerCableIndex !== -1) {
      powerGroup.powerCables[defaultPowerCableIndex].quantity = 1;
    }
    // Recalculate powerDisconnector
    tmpCalculatedElectricalInstallation.powerGroups.push(powerGroup);
    if (isTrackClosed) {
      tmpCalculatedElectricalInstallation.powerDisconnector.quantity =
        tmpCalculatedElectricalInstallation.powerGroups.length === 1
          ? 0
          : tmpCalculatedElectricalInstallation.powerGroups.length;
    } else {
      tmpCalculatedElectricalInstallation.powerDisconnector.quantity =
        tmpCalculatedElectricalInstallation.powerGroups.length - 1;
    }

    // Number of "Power Interconnects"
    const numberOfPowerInterconnects = tmpCalculatedElectricalInstallation.powerGroups.reduce(
      (acc, curr) => acc + curr.powerInterPlug.quantity,
      0
    );
    let powerInterconnectsQuantity = 0;
    if (isTrackClosed) {
      powerInterconnectsQuantity =
        nbSegments - numberOfPowerInterconnects - tmpCalculatedElectricalInstallation.powerDisconnector.quantity;
    } else {
      powerInterconnectsQuantity =
        nbSegments - numberOfPowerInterconnects - tmpCalculatedElectricalInstallation.powerDisconnector.quantity + 1;
    }
    // const piece_10_quantity = Math.floor(powerInterconnectsQuantity / 10);
    // const piece_1_quantity = Math.ceil(powerInterconnectsQuantity % 10);
    const piece_1_quantity = powerInterconnectsQuantity;
    const piece_1_index = tmpCalculatedElectricalInstallation.powerInterSeg.findIndex(
      (p) => p.quantityPerSet === "1_PIECE"
    );
    // const piece_10_index = tmpCalculatedElectricalInstallation.powerInterSeg.findIndex(
    //   (p) => p.quantityPerSet === "10_PIECES"
    // );
    tmpCalculatedElectricalInstallation.powerInterSeg[piece_1_index].quantity = piece_1_quantity;
    // tmpCalculatedElectricalInstallation.powerInterSeg[piece_10_index].quantity = piece_10_quantity;

    dispatch(setCalculatedElectricalInstallation(tmpCalculatedElectricalInstallation));
  };

  return (
    <div
      className={`flex flex-row items-center justify-center rounded border-[1px] border-solid ${
        !disabled ? "border-primary text-primary" : "border-gray-500 text-gray-500"
      }`}
    >
      <button
        onClick={() => addGroup()}
        type="button"
        className="flex justify-center items-center gap-x-2 rounded-sm py-2"
        disabled={disabled}
      >
        <MsxIcons name="add-flat" size="small" />
        <span className="font-medium capitalize">{t("mc12.ui.step.electrical.title.powergroup")}</span>
      </button>
    </div>
  );
};

export default AddPowerGroup;
